module.exports = __webpack_public_path__ + "static/img/Bachelor_010660.438d1a4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010660.jpg
// module id = 205
// module chunks = 0